import { useContext } from "react";
import { RegenerateInvoicePdfActionContext } from "./RegenerateInvoicePdfActionContext";

function usePrepareRegenerateInvoicePdf() {
  const { setShowModal, setInvoiceId } = useContext(RegenerateInvoicePdfActionContext);

  return (id: number) => {
    setInvoiceId(id);
    setShowModal(true);
  };
}

export default usePrepareRegenerateInvoicePdf;